const ABSOLUTE_TIMEOUT_MS = 24 * 60 * 60 * 1000; // 24 hours
const SESSION_START_KEY = "session_start";

// Stored in localStorage (not sessionStorage) so the absolute-timeout marker
// is shared across tabs of the same origin. Without this, a tab spawned via
// window.open sees an empty sessionStorage, treats the session as expired,
// and bounces to /login even when the user is genuinely signed in.
export class SessionTimeoutManager {
  static start(): void {
    localStorage.setItem(SESSION_START_KEY, Date.now().toString());
  }

  static hasSessionExpired(): boolean {
    const sessionStartStr = localStorage.getItem(SESSION_START_KEY);
    if (!sessionStartStr) return true;

    const sessionStartMs = Number(sessionStartStr);
    const sessionDurationMs = Date.now() - sessionStartMs;

    return sessionDurationMs > ABSOLUTE_TIMEOUT_MS;
  }

  static hasActiveSession(): boolean {
    return !!localStorage.getItem(SESSION_START_KEY);
  }

  static clear(): void {
    localStorage.removeItem(SESSION_START_KEY);
  }
}

export default SessionTimeoutManager;
